import { Stack } from "@mantine/core"
import { showNotification } from "@mantine/notifications"
import { TextCell } from "@tfg/ui"
import { useTranslation } from "react-i18next"

type Props = {
  supplierEmail: string
}

export const SupplierCell = ({ supplierEmail }: Props) => {
  const { t } = useTranslation()
  return (
    <Stack gap={0} fz="xs" c="var(--mantine-color-gray-6">
      <TextCell
        value={supplierEmail ?? undefined}
        copyable
        onCopy={() =>
          showNotification({
            color: "green",
            message: t("copy", {
              text: supplierEmail,
            }),
          })
        }
      />
    </Stack>
  )
}
